import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuthentication } from '../../contexts/AuthenticationContext'

const NavigationHandler = () => {
  const navigate = useNavigate()
  const { registerLogoutCallback } = useAuthentication()

  useEffect(() => {
    registerLogoutCallback(() => {
      navigate('/login', { replace: true })
    })
  }, [navigate, registerLogoutCallback])

  return null
}

export default NavigationHandler
